import { render, staticRenderFns } from "./BrSearchInput.vue?vue&type=template&id=0bdfdb02&"
import script from "./BrSearchInput.vue?vue&type=script&lang=js&"
export * from "./BrSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./BrSearchInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports